<template>
  <div class="block page16 f-r f-c">
    <PageHeader
      :title="moduleData['3_16_1_1']"
      :sub-title="moduleData['3_16_1_1_en']"
      :page-logo="reportCustomization.pageLogo"
    />
    <PageTips :page-num="pageNum"/>
    <div class="page16-body f-r j-b">
      <div class="page16-body-left">
        <TableNav width="900px" style="margin-bottom: 20px">
          <template v-slot:title>{{ moduleData["3_16_2_2"] }}</template>
<!--          <template v-slot:subtitle> 总购物中心数量：{{catData?.length || 0}} 个</template>-->
        </TableNav>
        <PTable :col-data="colData" :row-data="rowData.slice(0,10)" style="height: 706px">
          <Empty :text="PAGE_TEXT[commonLang].noShoppingCenterCoverage" v-if="!rowData.length"/>
        </PTable>
      </div>
      <div class="page16-body-right f-c">
        <div class="page10-map" id="page10Map">
          <Empty :text="PAGE_TEXT[commonLang].noShoppingCenterCoverage" v-if="!catData.length && !polygonData.length"/>
        </div>
        <div class="page10-map-tips">
          <div
            v-if="reportCustomization.showWater"
            class="page-tips2" style="margin-bottom:18px"
          >{{ PAGE_TEXT[commonLang].moreInfo }}</div>
          <div v-if="reportCustomization.showDataSource">
            {{ PAGE_TEXT[commonLang].dataSource }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageHeader from "./components/PageHeader";
import PageTips from "./components/PageTips";
import TableNav from "./components/TableNav";
import PTable from "./components/PTable";
import Empty from "./components/Empty";

import AMapLoader from "@amap/amap-jsapi-loader";
import { AMAP_KEY } from "@/constants/common";
import { shallowRef } from "@vue/reactivity";

import { computed, onMounted, ref } from "vue";
import { mapAddCircle, mapAddPolygon, addMapCenter, mapAddPolygonV2 } from "@/utils/pdf";
import { useStore } from "vuex";
import { getBusPolygon, drawMapKeepAlive } from "@/api/apiv2";

import { getMapDelayByMarkerCount } from '@/utils'

const props = defineProps({
    pageNum: String,
    cityInfo: {
        type: Object,
        default: () => {
            return {};
        },
    },
    catData: {
        type: Array,
        default: () => [],
    },
    moduleData: {
      type: Object,
      default: () => {
        return {

        };
      },
    },
    reportCustomization: {
      type: Object,
      default: () => {},
    },
    commonLang: {
      type: String,
      default: 'zh'
    }
  });

const PAGE_TEXT = {
  'zh': {
    noShoppingCenterCoverage: '当前区域暂无购物中心覆盖',
    moreInfo: '>当前图表中只展示部分购物中心，全部购物中心详情于APP「项目招商」中查看',
    dataSource: '数据来源：位置厂商数据，边界房产大数据',
    serialNumber: '序号',
    projectName: '项目名称',
    openingTime: '开业时间',
    commercialArea: '商业面积',
    distance: '距离'
  },
  'en': {
    noShoppingCenterCoverage: 'No shopping center coverage in current area',
    moreInfo: '',
    dataSource: 'Data Source: Location vendor data, Boundary real estate big data',
    serialNumber: 'No.',
    projectName: 'Project Name',
    openingTime: 'Opening Time',
    commercialArea: 'Commercial Area',
    distance: 'Distance'
  }
};

        const polygonData = ref([])
        const store = useStore()
        const colData = computed(() => [
            { prop: "index", width: "67px", label: PAGE_TEXT[props.commonLang].serialNumber },
            { prop: "projName", width: "300px", label: PAGE_TEXT[props.commonLang].projectName },
            { prop: "projOpentime", width: "170px", label: PAGE_TEXT[props.commonLang].openingTime },
            { prop: "projArea", width: "172px", label: PAGE_TEXT[props.commonLang].commercialArea },
            { prop: "distanceKilo", width: "100px", label: PAGE_TEXT[props.commonLang].distance, subLabel: 'km' },
        ]);

        const rowData = computed(() => {
            return props.catData.map((el,index) => {
                let _index = index + 1
                return {
                    index: _index < 10 ? ('0' + _index) : _index,
                    ...el
                }
            })
        });
        let map = shallowRef(null);
        const addMaker = (amap, map, newData) => {
            let markerList = [];
            newData.forEach((v) => {
                let content = `<div style="width: 12px;height: 12px; border-radius: 50%;background: #1644FF;"></div>`
                let marker = new amap.Marker({
                    position: new amap.LngLat(
                        v.projLng,
                        v.projLat,
                    ),
                    content
                });
                markerList.push(marker);
            });
            map.add(markerList);
        };
        onMounted(async () => {
          // 获取围栏
          try {
            const BusPolygonData = await getBusPolygon(store.state.baseReport.module1)
            polygonData.value = BusPolygonData.data || []
          } catch (e) {
            console.log(e);
          }

          AMapLoader.load({
              key: AMAP_KEY, // 申请好的Web端开发者Key，首次调用 load 时必填
              version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
              plugins: [""], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
          }).then((AMap) => {
            map = new AMap.Map("page10Map", {
              WebGLParams: {
                  preserveDrawingBuffer:true
              },
              dragEnable: false,
              zoomEnable: false,
              zoom: store.getters.mapZoom, //初始化地图级别
              center: props.cityInfo.location.split(","), //初始化地图中心点位置
            });
            const Polygon = mapAddPolygon(polygonData.value)
            Polygon.forEach(el => {
              map.add(el.polygon);
            })
            addMaker(AMap, map, [
                ...props.catData,
            ]);
            if (props.cityInfo.is_polygon) {
              mapAddPolygonV2(props.cityInfo?.polygon || '', map)
            } else {
              mapAddCircle(props.cityInfo, map);
            }
            addMapCenter(AMap, map, props.cityInfo.location)

            // 等待地图渲染
            const delay = getMapDelayByMarkerCount(props?.catData?.length || 0)
            drawMapKeepAlive(delay).catch((e) => {})

            map.setFitView()
          })
          .catch((e) => {
              console.log(e);
          });
        });
</script>

<style lang="less">
.page16 {
  position: relative;
  background: #ffffff;
  padding: 26px 60px 32px 0;
  .page16-body {
    flex-grow: 1;
    padding: 67px 20px 0 61px;
      .nav3 {
          font-size: 24px;
      }
    .page16-body-left {
      width: 900px;
    }
    .page16-body-right {
      width: 853px;
      .page10-map {
        width: 100%;
        height: 760px;
      }
      .page10-map-legend {
        flex-grow: 1;
        padding: 23px 0 23px 46px;
        .page10-map-legend-item {
          font-size: 20px;
          font-weight: 400;
          color: #333333;
          line-height: 28px;
          margin-right: 76px;
        }
        .page10-map-legend-item:last-child {
          margin-right: 0;
        }
        .page10-map-legend-icon {
          width: 22px;
          height: 22px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          margin-right: 12px;
        }
        .icon1 {
          background-image: url("~@/assets/机场.png");
        }
        .icon2 {
          background-image: url("~@/assets/火车站.png");
        }
        .icon3 {
          background-image: url("~@/assets/高铁站.png");
        }
        .page10-map-legend-point {
          width: 22px;
          height: 22px;
          margin-right: 12px;
          border-radius: 50%;
        }
        .point1 {
          background-color: #1644ff;
        }
        .point2 {
          background-color: #ff8116;
        }
      }
      .page10-map-tips {
        padding-top: 28px;
        flex-shrink: 0;
        text-align: right;
        font-size: 20px;
        font-weight: 400;
        color: #9a9a9a;
        line-height: 28px;
      }
    }
  }
}
</style>
